import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static values = { targetId: String, suggestion: String, annotationId: Number };

  accept() {
    const textarea = document.getElementById(this.targetIdValue);
    if (textarea) {
      const mdController = this.application.getControllerForElementAndIdentifier(textarea, "markdown-editor");
      if (mdController?.easyMDE) {
        mdController.easyMDE.value(this.suggestionValue);
      } else {
        textarea.value = this.suggestionValue;
      }
    }
    this.element.remove();
  }
}
